var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"card"},[_c('v-card',[_vm._t("content",null,null,_vm.$props)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }